import React from 'react';
import { CircularProgress } from '@material-ui/core';

const LoadingView = ({size = '6rem'}) => {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <CircularProgress size={size} thickness={1} />
    </div>
  );
};

export default LoadingView;
